<template>
  <ValidationObserver ref="observer" tag="form">
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <div id="mat-khau-nguoi-dung">
            <b-form-group
              class="required"
              label="Mật khẩu mới"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Mật khẩu"
                vid="password"
                rules="required|maxlength:50"
              >
                <div slot-scope="{ errors }">
                  <b-form-input
                    v-model="internalForm.newPassword"
                    type="password"
                    placeholder=""
                    :readonly="laTaoMoi"
                    rows="2"
                    max-rows="100"
                    no-resize
                    :class="{ 'is-danger': errors.length > 0 }"
                  />
                  <p :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              class="required"
              label="Xác nhận lại mật khẩu mới"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Xác nhận mật khẩu"
                rules="required|confirmed:password|maxlength:50"
              >
                <div slot-scope="{ errors }">
                  <b-form-input
                    v-model="internalForm.confirmPassword"
                    type="password"
                    placeholder=""
                    :readonly="laTaoMoi"
                    rows="2"
                    max-rows="100"
                    no-resize
                    :class="{ 'is-danger': errors.length > 0 }"
                  />
                  <p :class="{ error: errors.length > 0 }">{{ errors[0] }}</p>
                </div>
              </ValidationProvider>
            </b-form-group>
          </div>
        </b-form>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import _cloneDeep from "lodash/cloneDeep";
const defaultForm = {
  password: "",
  newPassword: "",
  confirmPassword: "",
};
export default {
  name: "QuanLyMatKhauNguoiDung",
  data() {
    return {
      internalForm: _cloneDeep(defaultForm),
      idCanBo: null,
      laTaoMoi: false,
      defaultId: "00000000-0000-0000-0000-000000000000",
    };
  },
  props: {
    form: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Object | null,
      required: false,
    },
    danhSachCanBo: {
      type: Array,
      default: () => {
        return [];
      },
    },
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array | null,
      required: false,
    },
  },
  watch: {
    form: {
      handler() {
        if (this.$route.params.id === "tao-moi") {
          this.internalForm = _cloneDeep(defaultForm);
        } else {
          this.internalForm = Object.assign({}, this.internalForm, this.form);
          if (this.form.profileId === this.defaultId) {
            this.internalForm.profileId = null;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    refreshForm() {
      this.internalForm = _cloneDeep(defaultForm);
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInternalForm() {
      return this.internalForm;
    },
  },
};
</script>


